module.exports = __webpack_public_path__ + "static/media/27.fb2265f9.png";